import { IconButton } from '@/lib';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { twMerge } from 'tailwind-merge';
import { StepPageActionsButton } from './types';
import SquareArrowLeft from '../../../../assets/icons/square-arrow-left.svg?react';

type StepPageActionsProps = {
  primaryButton: StepPageActionsButton;
  secondaryButton?: StepPageActionsButton;
  onBackButtonClick?: VoidFunction;
  classNames?: {
    wrapper?: string;
  };
};

export const StepPageActions: FC<StepPageActionsProps> = ({ primaryButton, secondaryButton, onBackButtonClick, classNames }) => {
  const { t } = useTranslation();

  const { text: primaryButtonText, intent: primaryButtonIntent = 'primary', trailingIcon: primaryButtonTrailingIcon, ...primaryButtonProps } = primaryButton;
  const {
    text: secondaryButtonText,
    intent: secondaryButtonIntent = 'secondary',
    trailingIcon: secondaryButtonTrailingIcon,
    ...secondaryButtonProps
  } = secondaryButton || {};

  return (
    <div className={twMerge('relative flex shrink-0 justify-center items-center gap-2.5 rounded-b-lg p-4', classNames?.wrapper)}>
      {onBackButtonClick && (
        <IconButton className='absolute left-4' intent='link-grey' text={t('COMMON:goBack')} leadingIcon={<SquareArrowLeft />} onClick={onBackButtonClick} />
      )}
      {secondaryButton && (
        <IconButton {...secondaryButtonProps} intent={secondaryButtonIntent} text={t(secondaryButtonText as any)} trailingIcon={secondaryButtonTrailingIcon} />
      )}

      <IconButton {...primaryButtonProps} intent={primaryButtonIntent} text={t(primaryButtonText as any)} trailingIcon={primaryButtonTrailingIcon} />
    </div>
  );
};
